import React from 'react';
import { Card, CardContent } from '@/components/base/Card';
import { Stethoscope, TreatmentNote } from '@/assets/icons';
import { ConsultationScrollArea } from '@/components/consultation/ConsultationScrollArea';
import { DiagnosisTiles } from './DiagnosisCard';
import { TreatmentRows } from './TreatmentCard';
import type { ClinicalAssessmentEntry } from '@/ayurveda/types/ayurveda';

export interface AITranscribedDataCardProps {
  entries: ClinicalAssessmentEntry[];
}

function SubHeading({ icon, children }: { icon: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-2">
      {icon}
      <h3 className="font-hanken text-[calc(20px*var(--app-scale))] font-medium leading-6 tracking-[0px] text-[#3C4F1E]">
        {children}
      </h3>
    </div>
  );
}

export function AITranscribedDataCard({ entries }: AITranscribedDataCardProps) {
  return (
    <Card padding="none" className="h-full overflow-hidden rounded-[24px] border-white bg-white">
      <ConsultationScrollArea className="h-full">
        <CardContent className="flex flex-col gap-4 py-4 pl-4 pr-2">
          <div className="flex flex-col gap-1 rounded-2xl border border-white bg-[#F3EBFF] px-4 py-2">
            <h2 className="font-serif text-[calc(20px*var(--app-scale))] font-medium leading-[30px] text-[#3C4F1E]">
              AI Transcribed data
            </h2>
            <p className="font-hanken text-sm font-medium tracking-[-0.16px] text-[#8D90A1]">
              Review the kiosk findings and provisional assessment.
            </p>
          </div>

          <SubHeading icon={<Stethoscope size={20} />}>Diagnosis</SubHeading>
          <DiagnosisTiles entries={entries} />

          <SubHeading icon={<TreatmentNote size={20} />}>Treatment</SubHeading>
          <TreatmentRows entries={entries} />
        </CardContent>
      </ConsultationScrollArea>
    </Card>
  );
}
